import * as angular from "angular";
import {IController, IWindowService} from "angular";
import * as _ from "lodash";
import {TextTemplatePurposeType} from "../../../text-templates/types/text-template-purpose.type";
import {TextTriggerGroupType} from "../../types/text-trigger-group.type";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {TextTemplatesRequestsService} from "../../../text-templates/services/text-templates-requests.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {TextTriggerType} from "../../types/text-trigger.type";
import {ActionReasonsServiceService} from "../../../action-reasons/services/action-reasons-service.service";
import {ActionReasonModel} from "../../../action-reasons/models/action-reason.model";
import {ActionReasonEnum} from "../../../action-reasons/enums/action-reason.enum";
import {SplitService} from "../../../commons/services/split-service.service";

export class NotificationsViewCtrl implements IController {

  notifications: any;
  type: any;
  accountId: any;
  purpose: TextTemplatePurposeType;

  private tagsRef: any;
  public tabs: any;
  public selectedTab: any;
  public notificationsByTextTriggerGroup: any;
  public cancellationTags: any;
  public selectedNotification: any;
  public selectedNavLanguage: any;
  public triggerLanguage: any;
  public siteTags: any;
  public fileTypes = undefined;
  public textTriggerGroupType: typeof TextTriggerGroupType = TextTriggerGroupType;
  public textTemplatePurposeType: typeof TextTemplatePurposeType = TextTemplatePurposeType;
  public textTriggerType: typeof TextTriggerType = TextTriggerType;
  public sitePrograms: any;

  constructor(private $mdSidenav, private splitService: SplitService, private textTemplatesRequestsService: TextTemplatesRequestsService,
              private commonsAlertsService: CommonsAlertsService, private bringozLoaderService: BringozLoaderService, private $log,
              private $tags, private $window: IWindowService, private actionReasonsService: ActionReasonsServiceService) {
  }

  $onInit() {

    this.tagsRef = this.$tags();
    this.sitePrograms = this.splitService.getSiteProgramTypes();

    this.tabs = Object.values(TextTriggerGroupType);
    this.selectedTab = this.tabs[0];

    this._getSiteTags();
    this._getCancellationTags();
    this.setNotificationsByTextTriggerGroup(this.selectedTab);

    this.cancellationTags = undefined;
    this.selectedNotification = undefined;
    this.selectedNavLanguage = undefined;

    this.triggerLanguage = undefined;
    this.siteTags = [];

    this.triggerLanguage = this.splitService.getLocaleCode();

  };

  // ******************************
  //        Public methods
  // ******************************

  setNotificationsByTextTriggerGroup(textTriggerGroup) {
    this.selectedTab = textTriggerGroup;
    this.notificationsByTextTriggerGroup = _.filter(this.notifications, (n) => {
      return n.textTriggerGroup === textTriggerGroup;
    })
  }

  onCloseSideNav() {
    this._toggleSideNav()
      .then(() => {
        this.selectedNotification = undefined;
        this.selectedNavLanguage = undefined;
      })
  }

  onEditNotification(notification) {
    this.selectedNotification = angular.copy(notification);
    this.selectedNavLanguage = 'en_US';
    this._toggleSideNav();
  }

  onReset(selectedNotification) {
    this.bringozLoaderService.on();
    this.textTemplatesRequestsService.resetTemplate(selectedNotification.id, this.accountId)
      .then((updatedNotification) => {
        this._updateNotification(updatedNotification);
        this.onCloseSideNav();
        this.commonsAlertsService.notificationResetSuccess();
      })
      .catch((error) => {
        this.commonsAlertsService.notificationResetError();
        this.$log.error('Failed to reset text template message @notificationsSmsRecipient@onReset', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onSave(selectedNotification) {
    this._saveNotification(selectedNotification)
      .then(() => {
        this.onCloseSideNav();
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _toggleSideNav() {
    return this.$mdSidenav('right').toggle();
  }

  private _saveNotification(selectedNotification) {
    const notificationCopy = angular.copy(selectedNotification);
    const action = selectedNotification.id ? 'editTemplate' : 'createTemplate'; // If has no idea needs to create it.

    notificationCopy.textTemplatePurpose = this.purpose;

    // server request to remove these before updating/creating.
    _.unset(notificationCopy, 'defaults');
    _.unset(notificationCopy, 'tagItems');
    _.unset(notificationCopy, 'description');

    this.bringozLoaderService.on();
    return this.textTemplatesRequestsService[action](notificationCopy, notificationCopy.id, this.accountId)
      .then((updatedNotification) => {
        this._updateNotification(updatedNotification);
        this.commonsAlertsService.notificationUpdateSuccess();
      })
      .catch((error) => {
        this.commonsAlertsService.notificationUpdateError();
        this.$log.error('Failed to save text template message @notificationsSmsRecipient@onSave', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private _updateNotification(updatedNotification) {
    const notificationIndex = _.findIndex(this.notifications, (notification: any) => {
      return notification.trigger === updatedNotification.trigger;
    });
    if (notificationIndex !== -1) {
      this.notifications[notificationIndex] = updatedNotification;
      this.setNotificationsByTextTriggerGroup(this.selectedTab);
    }
  }

  private _getSiteTags() {
    this.tagsRef.$getAll()
      .then((tagIds) => {
        return this.tagsRef.$asyncValues(tagIds);
      })
      .then((siteTags) => {
        this.siteTags = siteTags;
      });
  }

  private _getCancellationTags() {
    this.actionReasonsService.getActionReasons(undefined, undefined, [ActionReasonEnum.Cancel]).then((actionReasons: ActionReasonModel[]) => {
      this.cancellationTags = _.map(actionReasons, (cr) => {
        return {reason: cr.reason, id: cr.id};
      });
    })
  }

}

angular
  .module('bringoz.admin.notifications')
  .component('notificationsView', {
    bindings: {
      notifications: '<',
      type: '<',
      accountId: '<?',
      purpose: '<'
    },
    template: require('./notifications-view.html').default,
    controller: NotificationsViewCtrl
  });
